import '../css/DiscountsPage.css';
import { useEffect, useState } from "react";
import ProductItem from "../components/ProductItem";
import Cookies from 'js-cookie';
import SimpleAlert from '../components/SimpleAlert';
import SessionAlert from '../components/SessionAlert'
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import google_menu from '../assets/google_menu.svg'
import DesktopCategoriesBar from '../components/DesktopCategoriesBar';
import MobileCategoriesBar from '../components/MobileCategoriesCar';
import { fetchJson, responseArray } from '../utils/apiFetch';

export default function DiscountsPage() {
    const [data, setData] = useState([]);
    const [totalProducts, setTotalProducts] = useState(0);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [language, setLanguage] = useState('english');
    const [options, setOptions] = useState([]);
    const [maxPrice, setMaxPrice] = useState(0);
    const [error, setError] = useState(null);
    const [selectedBrands, setSelectedBrands] = useState([]);
    const [priceRange, setPriceRange] = useState([0, maxPrice]);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const productsPerPage = 12;

    useEffect(() => {
        fetchInitialProducts();
        fetchTotalProducts();
    }, []);

    useEffect(() => {
        fetchProductsByPage(currentPage);
    }, [currentPage]);

    const fetchInitialProducts = async () => {
        try {
            if (Cookies.get('language')) {
                setLanguage(Cookies.get('language'));
            } else {
                Cookies.set('language', 'english');
                setLanguage('english');
            }
            await fetchProductsByPage(1);
        } catch (error) {
            console.error('Error fetching initial products:', error);
            setError('Failed to fetch initial products.');
        }
    };

    const fetchTotalProducts = async () => {
        try {
            const { count } = await fetchJson('/api/product/discounted/count');
            const safeCount = Number(count || 0);
            setTotalProducts(safeCount);
            setTotalPages(Math.ceil(safeCount / productsPerPage));
        } catch (error) {
            console.error('Error:', error);
            setError('Failed to fetch total product count.');
        }
    };

    const fetchProductsByPage = async (page) => {
        setLoading(true);
        if(data.length > 0) {
            setData([])
        }
        try {
            const response = await fetchJson(`/api/product/discounted/page?page=${page}&limit=${productsPerPage}`);
            const products = responseArray(response, 'products');
            const uniqueBrands = [...new Set(products.map(product => product.brand))];
            const newOptions = uniqueBrands.map(brand => ({
                label: brand,
                value: brand
            }));
            setOptions(newOptions);
            setData(products);
        } catch (error) {
            console.error('Error:', error);
            setError('Failed to fetch products.');
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleCheckboxChange = (event) => {
        const { value } = event.target;
        setSelectedBrands(prevSelectedBrands =>
            prevSelectedBrands.includes(value)
                ? prevSelectedBrands.filter(brand => brand !== value)
                : [...prevSelectedBrands, value]
        );
    };

    const handlePriceChange = (event, newValue) => {
        setPriceRange(newValue); // Update the selected price range
    };

    const filteredData = data.filter(product =>
        selectedBrands.length === 0 || selectedBrands.includes(product.brand)
    );

    const categories = {
        'pain_killers': (language === 'arabic') ? 'مسكنات الألم' : 'Pain killers',
        'vitamins': (language === 'arabic') ? 'الفيتامينات' : 'Vitamins',
        'colds': (language === 'arabic') ? 'سعال البرد' : 'Cold/cough',
        'body_care': (language === 'arabic') ? 'العناية بالجسم' : 'Body care',
        'hygiene': (language === 'arabic') ? 'صحة' : 'Hygiene',
        'first_aid': (language === 'arabic') ? 'إسعافات أولية' : 'First aid',
    };

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    return (
        <div dir={language === 'arabic' ? 'rtl' : 'ltr'} className='discountpage-container' style={{marginLeft: isCollapsed ? '' : '0', marginRight: isCollapsed ? '' : '0'}}>
            <SessionAlert />
            {/* <h2 id='category-h2'>{categories[category]}</h2> */}
            <MobileCategoriesBar class_name={'side-bar'} {...{language, toggleSidebar, isCollapsed, priceRange, handlePriceChange, maxPrice, options, selectedBrands, loading, handleCheckboxChange }}/>
            <div className='mobile-categorymenu' style={{ opacity: isCollapsed ? 1 : 0.5}}>
                <button onClick={toggleSidebar}>
                    <img src={google_menu}></img>
                </button>
                {/* <h2 id='category-h2'>{categories[category]}</h2> */}
            </div>
            <section className={`big-discount-container ${isCollapsed ? '' : 'bigdiscount-opacity'}`} style={{ opacity: isCollapsed ? 1 : 0.5}}>
                <SimpleAlert id="addcart-alert" key="alert" message="Added to cart" type='success' />
                <DesktopCategoriesBar class_name={'side-bar'} {...{language, isCollapsed, priceRange, handlePriceChange, maxPrice, options, selectedBrands, loading, handleCheckboxChange }}/>
                
                
                <aside className="productsAside">
                    <div className="discounts-container">
                        {Array.from({ length: loading ? productsPerPage : 0 }).map((_, index) => (
                            <Box key={index} sx={{ pt: 0.5, display: loading ? 'block' : 'none' }}>
                                <Skeleton variant="rectangular" width={210} height={118} />
                                <Skeleton />
                                <Skeleton width="60%" />
                            </Box>
                        ))}
                        {error ? (
                            <div>Error: {error}</div>
                        ) : (
                            filteredData.map(product => (
                                <ProductItem key={product._id} product={product} nb_in_stock={product.nb_in_stock} language={language}/>
                            ))
                        )}
                    </div>
                    <div className='discounts-pagination'>
                        <Stack spacing={2}>
                            <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={handlePageChange}
                                variant="outlined"
                                color="primary"
                            />
                        </Stack>
                    </div>
                </aside>
            </section>
        </div>
    );
}
